module.exports = __webpack_public_path__ + "static/media/nigeria.c61c7680.svg";